<template>
  <div class="condition-editor">
    <div class="tip" v-if="!sheet.id">
      <div>请先选择工作表</div>
    </div>
    <div v-else class="content-wrap">
      <div class="rule-list">
        <ul>
          <li
            v-for="(rule, index) in value"
            :key="index"
            class="list-item"
            :class="{ active: currentRuleIdx == index }"
            @click="currentRuleIdx = index"
          >
            <span class="color-Gray_9e">{{ index + 1 }}、</span>
            <div class="main">
              <div v-if="rule.name.length">
                {{ rule.name }}
              </div>
              <div class="color-Gray_9e">{{ tip }}</div>
            </div>
            <div class="operation color-Gray_9e">
              <base-button
                type="text"
                icon="el-icon-edit"
                @click="openConditionDialog(index)"
              ></base-button>
              <base-button
                type="text"
                icon="el-icon-delete-solid"
                @click="deleteRule(index)"
              ></base-button>
            </div>
          </li>
          <li class="add-box" @click="openConditionDialog()">+ 添加新{{ type }}</li>
        </ul>
      </div>
    </div>
    <save-condition-dialog
      ref="saveConditionDialog"
      :sheet="sheet"
      :type="type"
      @submit="conditionSubmit"
    ></save-condition-dialog>
  </div>
</template>

<script>
import BaseButton from "@/components/UIComponents/Button"
import SaveConditionDialog from "./SaveConditionDialog"

export default {
  name: "condition-editor",
  components: {
    SaveConditionDialog,
    BaseButton
  },
  data() {
    return {
      currentRuleIdx: -1
    }
  },
  props: {
    value: {
      type: Array,
      default: () => []
    },
    tip: {
      type: String,
      default: "满足条件才可同步"
    },
    sheet: Object,
    type: {
      type: String,
      default: "规则"
    }
  },
  methods: {
    // 删除一个字段规则
    deleteRule(index) {
      this.$emit("delete", this.value[index])
      this.currentRuleIdx = -1
      this.value.splice(index, 1)
      this.emitValue(this.value)
    },
    emitValue(value) {
      this.$emit("input", value)
    },
    openConditionDialog(index = -1) {
      this.currentRuleIdx = index
      this.$refs.saveConditionDialog.open(index < 0 ? null : this.value[index])
    },
    conditionSubmit(condition) {
      if (this.currentRuleIdx < 0) {
        this.emitValue(this.value.concat(condition))
      } else {
        this.value.splice(this.currentRuleIdx, 1, condition)
        this.emitValue(this.value)
      }
      this.$emit("update", condition)
    }
  }
}
</script>

<style lang="scss" scoped>
.condition-editor {
  display: flex;
  .tip {
    flex: 1;
    height: 36px;
    line-height: 36px;
    background: #f8f8f8;
    border-radius: 4px;
    padding: 0 17px;
    box-sizing: border-box;
    color: #c0c4cc;
  }
  .content-wrap {
    flex: 1 1;
    box-sizing: border-box;
    .title {
      font-size: 16px;
    }
    .title-tips {
      font-size: 14px;
    }
    .rule-list {
      li {
        cursor: pointer;
        &:hover {
          background-color: #e9f5fe;
        }
      }
      .list-item {
        display: flex;
        line-height: 23px;
        margin-bottom: 12px;
        padding: 10px 10px;
        font-size: 13px;
        background-color: #f7f7f7;
        border-radius: 4px;
        box-sizing: border-box;
        &.active {
          background-color: #e9f5fe;
        }
        .main {
          flex: 1 1;
          .tip-text {
            margin-left: 6px;
          }
        }
        .operation {
          .el-icon-delete-solid {
            padding: 2px;
            &:hover {
              color: #f44336;
            }
          }
        }
      }
      .add-box {
        height: 66px;
        border-radius: 4px;
        color: #2196f3;
        text-align: center;
        line-height: 66px;
        font-size: 14px;
        border: 1px dashed #ccc;
        &:hover {
          color: #0073ce;
          border: 1px dashed #2196f3;
        }
      }
    }
  }
  ::v-deep .base-button {
    color: #a1a1a1;
    &:hover {
      color: #1989fa;
    }
  }
}
</style>
